var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgScheduleIcon = function SvgScheduleIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero",
    transform: "translate(8 9)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.55,
    d: "M11.16.96h-1.08V.24a.24.24 0 1 0-.48 0v.72H2.4V.24a.24.24 0 0 0-.48 0v.72H.84A.84.84 0 0 0 0 1.8v9.36c0 .463.377.84.84.84h10.32a.84.84 0 0 0 .84-.84V1.8a.84.84 0 0 0-.84-.84zM.84 1.44h1.08v.72a.24.24 0 0 0 .48 0v-.72h7.2v.72a.24.24 0 1 0 .48 0v-.72h1.08a.36.36 0 0 1 .36.36v1.56H.48V1.8a.36.36 0 0 1 .36-.36zm10.32 10.08H.84a.36.36 0 0 1-.36-.36V3.84h11.04v7.32a.36.36 0 0 1-.36.36z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.08,
    cy: 5.52,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 5.52,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.92,
    cy: 5.52,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.84,
    cy: 5.52,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.16,
    cy: 7.44,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.08,
    cy: 7.44,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 7.44,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.92,
    cy: 7.44,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.84,
    cy: 7.44,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.16,
    cy: 9.36,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.08,
    cy: 9.36,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 9.36,
    r: 1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    stroke: "#EFF3F6",
    strokeWidth: 1.05,
    d: "M12.013 3v3.255H9L14 11l5-4.745h-3V3z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgScheduleIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/schedule-icon.7fadf161a3989ce115abf21eedfd5b08.svg";